
import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function Home() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const heroSlides = [
    {
      image: 'https://public.readdy.ai/ai/img_res/7285b43188327e21f25c8f94b7ff3547.jpg',
      title: 'Digital Solutions',
      subtitle: 'Transforming Ideas into Digital Excellence'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=creative%20marketing%20team%20collaboration%20with%20designers%20and%20strategists%20working%20together%20large%20screens%20displaying%20branding%20materials%20marketing%20visuals%20video%20editing%20software%20and%20analytics%20dashboards%20professional%20aspirational%20international%20atmosphere%20premium%20creative%20studio%20environment%20with%20modern%20aesthetic%20cinematic%20lighting%20representing%20creative%20excellence%20and%20innovation&width=1920&height=1080&seq=hero-slide-2&orientation=landscape',
      title: 'Creative Excellence',
      subtitle: 'Crafting Brands That Inspire and Connect'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=luxury%20business%20travel%20scene%20with%20modern%20international%20airport%20private%20lounge%20elegant%20waiting%20area%20business%20travelers%20with%20luggage%20premium%20travel%20experience%20clean%20sophisticated%20global%20mobility%20visuals%20representing%20world%20class%20travel%20services%20cinematic%20lighting%20high%20end%20lifestyle%20photography%20sleek%20contemporary%20design%20aesthetic&width=1920&height=1080&seq=hero-slide-3&orientation=landscape',
      title: 'Global Travel Convenience',
      subtitle: 'Your Gateway to Seamless Worldwide Journeys'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=modern%20corporate%20boardroom%20with%20business%20executives%20in%20strategy%20meeting%20large%20screens%20showing%20global%20map%20overlays%20data%20visualizations%20and%20innovation%20graphics%20professional%20leadership%20atmosphere%20representing%20business%20growth%20and%20expansion%20premium%20office%20environment%20with%20confident%20energy%20cinematic%20lighting%20high%20end%20corporate%20photography%20sleek%20design&width=1920&height=1080&seq=hero-slide-4&orientation=landscape',
      title: 'Business Growth & Innovation',
      subtitle: 'Driving Success Through Strategic Excellence'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=diverse%20group%20of%20international%20professionals%20entrepreneurs%20and%20creative%20individuals%20collaborating%20together%20representing%20global%20connection%20and%20success%20premium%20corporate%20environment%20showing%20teamwork%20and%20community%20modern%20office%20setting%20with%20natural%20lighting%20professional%20storytelling%20photography%20representing%20brand%20impact%20and%20collaboration%20cinematic%20aesthetic%20high%20end%20business%20photography&width=1920&height=1080&seq=hero-slide-5&orientation=landscape',
      title: 'Brand Impact & Community',
      subtitle: 'Building Connections That Drive Global Success'
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [heroSlides.length]);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section with Slider */}
      <section className="relative h-screen flex items-center justify-center overflow-hidden">
        {/* Animated Background Slider */}
        <div className="absolute inset-0 z-0">
          {heroSlides.map((slide, index) => (
            <div
              key={index}
              className={`absolute inset-0 transition-all duration-1000 ease-in-out ${
                index === currentSlide
                  ? 'opacity-100 translate-x-0'
                  : index === (currentSlide - 1 + heroSlides.length) % heroSlides.length
                  ? 'opacity-0 -translate-x-full'
                  : 'opacity-0 translate-x-full'
              }`}
              style={{
                backgroundImage: `url(${slide.image})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center'
              }}
            >
              <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/60 to-black/40"></div>
            </div>
          ))}
        </div>

        {/* Slide Indicators */}
        <div className="absolute bottom-6 sm:bottom-8 left-1/2 transform -translate-x-1/2 z-20 flex gap-2 sm:gap-3">
          {heroSlides.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentSlide(index)}
              className={`w-2 h-2 sm:w-3 sm:h-3 rounded-full transition-all duration-300 cursor-pointer ${
                index === currentSlide
                  ? 'bg-yellow-400 w-6 sm:w-8'
                  : 'bg-white/50 hover:bg-white/80'
              }`}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
        
        {/* Hero Content */}
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 text-white w-full">
          <div className="max-w-3xl">
            <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold mb-4 sm:mb-6 leading-tight">
              Afriq Global
            </h1>
            <p className="text-xl sm:text-2xl md:text-3xl lg:text-4xl mb-6 sm:mb-8 font-light">
              Digital Solutions. Creative Excellence. Global Travel Convenience.
            </p>
            <p className="text-base sm:text-lg md:text-xl mb-8 sm:mb-10 text-gray-200 leading-relaxed">
              Afriq Global is a dynamic and innovative company delivering top-tier digital marketing, creative services, and seamless travel experiences.
            </p>
            <div className="flex flex-col sm:flex-row flex-wrap gap-3 sm:gap-4">
              <Link 
                to="/about" 
                className="px-6 sm:px-8 py-3 sm:py-4 bg-yellow-500 hover:bg-yellow-600 text-black font-semibold rounded-lg transition-all duration-300 whitespace-nowrap cursor-pointer text-sm sm:text-base text-center"
              >
                Learn More
              </Link>
              <Link 
                to="/contact" 
                className="px-6 sm:px-8 py-3 sm:py-4 bg-white/10 hover:bg-white/20 backdrop-blur-sm border-2 border-white text-white font-semibold rounded-lg transition-all duration-300 whitespace-nowrap cursor-pointer text-sm sm:text-base text-center"
              >
                Contact Us
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Feature Sections */}
      <section className="py-16 sm:py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-12 sm:mb-16">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-3 sm:mb-4">Our Services</h2>
            <p className="text-lg sm:text-xl text-gray-600">Comprehensive solutions for your business and travel needs</p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8">
            {/* Almadaa Digital */}
            <div className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer group">
              <div className="h-64 sm:h-72 md:h-80 overflow-hidden">
                <img 
                  src="https://readdy.ai/api/search-image?query=professional%20digital%20marketing%20agency%20workspace%20with%20creative%20team%20working%20on%20social%20media%20campaigns%20modern%20office%20with%20computers%20and%20design%20tools%20vibrant%20creative%20atmosphere%20Dubai%20business%20setting%20photography%20and%20videography%20equipment%20visible%20royal%20blue%20and%20gold%20brand%20colors%20professional%20marketing%20materials%20on%20display&width=800&height=600&seq=almadaa1&orientation=landscape"
                  alt="Almadaa Digital Marketing"
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="p-6 sm:p-8">
                <h3 className="text-2xl sm:text-3xl font-bold text-yellow-600 mb-3 sm:mb-4">Almadaa Digital Marketing Management</h3>
                <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 leading-relaxed">
                  A Dubai Mainland registered digital agency delivering modern marketing and creative solutions. From social media management to web development, we empower brands with creative excellence and measurable results.
                </p>
                <Link 
                  to="/almadaa-digital" 
                  className="inline-flex items-center text-yellow-600 font-semibold hover:text-yellow-700 transition-colors cursor-pointer whitespace-nowrap text-sm sm:text-base"
                >
                  Explore Services <i className="ri-arrow-right-line ml-2"></i>
                </Link>
              </div>
            </div>

            {/* Dennywise Travel */}
            <div className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer group">
              <div className="h-64 sm:h-72 md:h-80 overflow-hidden">
                <img 
                  src="https://readdy.ai/api/search-image?query=luxury%20travel%20and%20tourism%20concept%20with%20Dubai%20landmarks%20Burj%20Khalifa%20and%20modern%20architecture%20airplane%20in%20sky%20hotel%20resort%20beach%20vacation%20destination%20logistics%20and%20shipping%20containers%20professional%20travel%20agency%20atmosphere%20golden%20hour%20lighting%20premium%20travel%20experience%20world%20class%20service%20imagery&width=800&height=600&seq=travel1&orientation=landscape"
                  alt="Dennywise Travel and Logistics"
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="p-6 sm:p-8">
                <h3 className="text-2xl sm:text-3xl font-bold text-yellow-600 mb-3 sm:mb-4">Afriq Travel and Logistics</h3>
                <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 leading-relaxed">
                  World-class travel services including flight bookings, hotel reservations, tourism packages, and comprehensive shipment and logistics solutions. Your gateway to seamless global travel experiences.
                </p>
                <Link 
                  to="/dennywise-travel" 
                  className="inline-flex items-center text-yellow-600 font-semibold hover:text-yellow-700 transition-colors cursor-pointer whitespace-nowrap text-sm sm:text-base"
                >
                  Discover Travel Services <i className="ri-arrow-right-line ml-2"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Banner */}
      <section className="py-20 sm:py-24 bg-gradient-to-r from-yellow-500 via-yellow-600 to-yellow-500 relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{
            backgroundImage: 'repeating-linear-gradient(45deg, transparent, transparent 35px, rgba(255,255,255,.1) 35px, rgba(255,255,255,.1) 70px)'
          }}></div>
        </div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 text-center relative z-10">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-black mb-4 sm:mb-6">
            Your One-Stop Hub for Digital Growth and Global Travel Solutions
          </h2>
          <p className="text-lg sm:text-xl text-gray-900 mb-8 sm:mb-10 max-w-3xl mx-auto">
            Partner with Afriq Global to elevate your business and explore the world with confidence
          </p>
          <div className="flex flex-col sm:flex-row flex-wrap justify-center gap-3 sm:gap-4">
            <Link 
              to="/contact" 
              className="px-8 sm:px-10 py-3 sm:py-4 bg-black hover:bg-gray-900 text-white font-bold rounded-lg transition-all duration-300 whitespace-nowrap cursor-pointer text-sm sm:text-base"
            >
              Get Started Today
            </Link>
            <Link 
              to="/why-choose-us" 
              className="px-8 sm:px-10 py-3 sm:py-4 bg-white hover:bg-gray-100 text-black font-bold rounded-lg transition-all duration-300 whitespace-nowrap cursor-pointer text-sm sm:text-base"
            >
              Why Choose Us
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
